import { useEffect, useState } from 'react';
import { getStaysEntitlement } from '../../api/stays-client';
import { StaysEntitlement } from '../../interfaces/stays';

// Lobbero Stays — does this ORGANISATION have Stays, and what does the
// platform policy say (plan S1; the `useIqEntitlement` shape).
//
// Not-loaded reads OFF and any error reads OFF: a Stays entry that then 404s is
// worse than none. `enabled` is not optional plumbing — without it this would
// fire GET /api/stays/entitlement for every signed-in person, including a
// concierge (403, no stays:read) and a resident (403 at the staff gate).
export const useStaysEntitlement = (opts?: {
  enabled?: boolean;
}): { state: StaysEntitlement | null; loading: boolean } => {
  const enabled = opts?.enabled !== false;
  const [state, setState] = useState<StaysEntitlement | null>(null);
  const [loading, setLoading] = useState<boolean>(enabled);

  useEffect(() => {
    if (!enabled) {
      setState(null);
      setLoading(false);

      return;
    }
    let alive = true;
    setLoading(true);
    getStaysEntitlement()
      .then(s => {
        if (alive) {
          setState(s);
          setLoading(false);
        }
      })
      .catch(() => {
        // Fail closed: any error means Stays is off. Never optimistic.
        if (alive) {
          setState(null);
          setLoading(false);
        }
      });

    return () => {
      alive = false;
    };
  }, [enabled]);

  return { state, loading };
};

/** True only when the entitlement has loaded and says the organisation has Stays. */
export const staysIsOn = (state: StaysEntitlement | null): boolean => state?.enabled === true;
